module.exports = function (name, classes, styles) {
    if (typeof classes == 'object') {
        classes = undefined;
    }
    if (typeof styles == 'object') {
        styles = undefined;
    }

    return '<i class="fas fa-' + name + ' ' + classes + '" style="' + styles + '"></i>';
}
